<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    :color="tbColor"
    dark flat style="border-bottom: 1px solid #111 !important"
  >
    <v-toolbar-title class="headline" style="width: 240px; margin-left: 0px">
      <span>backOffice</span>
    </v-toolbar-title>

    <v-text-field
      hide-details
      filled
      flat
      clear-icon="close"
      append-icon="search"
      label="Искать по имени, id, карте, телефону, имейлу"
      @input="debouncedSearch"
      @click:append="saveSearch"
      v-model="search"
      clearable
      style="max-width: 500px;"
    ></v-text-field>

    <v-spacer></v-spacer>

    <v-progress-circular v-if="inAction" indeterminate size="20" color="secondary" class="mx-3"></v-progress-circular>
    <v-card flat dark class="py-1 px-2 darkligth" v-if="profile">
      {{profile.email}}
      <v-icon small>vpn_key</v-icon>
      {{profile.orgid}}
    </v-card>

    <v-btn color="secondary" text v-if="(ready === true) && !profile" href="#/login">Войти</v-btn>
    <v-btn color="secondary" text v-if="profile" @click="$store.dispatch('logout')" icon>
      <v-icon>logout</v-icon>
    </v-btn>

  </v-app-bar>
</template>

<script>
import debounce from 'debounce'
let i = 0
export default {
  name: 'ToolbarMenu',
  data: () => ({
    search: null,
    tbColor: '#044F67',
    colors: [
      '#317589',
      '#044F67',
      '#003171',
      '#264348',
      '#5D3F6A',
      '#8F1D21',
      '#9D2933',
    ]
  }),
  methods: {
    saveSearch () {
      this.$store.dispatch('search', this.search)
    },
    swithColor () {
      i++
      this.tbColor = this.colors[i % this.colors.length]
    }
  },
  computed: {
    ready () {
      return this.$store.state.ready
    },
    profile () {
      return this.$store.state.profile
    },
    inAction () {
      return this.$store.state.tasksInAction > 0
    },
    debouncedSearch () {
      return debounce(this.saveSearch, 300)
    }
  }
}
</script>

<style lang="css">
</style>
